import { createContext, useState, Dispatch, SetStateAction } from "react";

export interface isDragContextProps {
  isDrag: boolean;
  setIsDrag: Dispatch<SetStateAction<boolean>>;
}

export const isDragContext = createContext<isDragContextProps>({
  isDrag: false,
  setIsDrag: () => {},
});

export function IsDragContextProvider(props: { children: React.ReactNode }) {
  const [isDrag, setIsDrag] = useState<boolean>(false);

  return (
    <isDragContext.Provider value={{ isDrag, setIsDrag }}>
      {props.children}
    </isDragContext.Provider>
  );
}
